import { Component, input, output } from '@angular/core';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventFiltering,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TSearchAdvancedFilterOperator } from '../../points/point-search/point-search.consts';
import { TAdvancedFilterSingle, TSearchFilterRow } from '../models/advanced-filter.model';

@Component({
  selector: 'pp-advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss'],
  standalone: false,
})
export class AdvancedFiltersComponent {
  ppFilters = input<TSearchFilterRow[]>();
  ppFiltersChange = output<TSearchFilterRow[]>();

  ppOperator = input<TSearchAdvancedFilterOperator>();
  ppOperatorChange = output<TSearchAdvancedFilterOperator>();

  EIconPath = EIconPath;
  ppWorkspaceId = input<string>();

  addNewFilter(): void {
    const newFilter: TSearchFilterRow = {
      item: {
        // this is the shape that the row expects
        type: undefined,
        value: undefined,
        option: undefined,
        id: undefined,
        customFields: [],
      },
      keys: [],
      values: [],
      operator: undefined,
      timelinePosition: undefined,
    };

    const newFilters: TSearchFilterRow[] = [...this.ppFilters(), newFilter];

    this.ppFiltersChange.emit(newFilters);

    logEventInGTAG(EGoogleEventFiltering.ADD_ADVANCED_FILTER, {
      source: EGoogleEventCategory.FILTERING,
    });
  }

  deleteFilter(index: number): void {
    const newFilters = this.ppFilters().filter((filter, filterIndex) => filterIndex !== index);
    this.ppFiltersChange.emit(newFilters);
  }

  updateFilter(index: number, newFilter: TAdvancedFilterSingle): TSearchFilterRow[] {
    const newFilters = [...this.ppFilters()];
    const currentFilter = newFilters.find((filter, filterIndex) => filterIndex === index);

    currentFilter.keys = newFilter.customFields?.length ? newFilter.customFields : [newFilter.id];
    currentFilter.operator = newFilter.operator ?? currentFilter.operator;

    currentFilter.timelinePosition = newFilter.timelinePosition ? newFilter.timelinePosition : null;

    if (Array.isArray(newFilter.value)) {
      currentFilter.values = newFilter.value.map((item) => {
        if (item === null || item === '' || Array.isArray(item)) {
          return item;
        } else {
          return item.toString();
        }
      });
    } else {
      currentFilter.values =
        newFilter.value != null && newFilter.value !== '' ? [newFilter.value.toString()] : [];
    }

    currentFilter.item = {
      ...newFilter,
    };

    this.ppFiltersChange.emit(newFilters);

    return newFilters;
  }
}
